import React, { Dispatch, SetStateAction, useRef, useState } from 'react';
import styled from 'styled-components';
import { Icon as KuiIcon } from '@successmode-ktp/kui';

import menuBarIcon from '@/assets/common/menuBar.png';
import ErrorMessage from '../common/ErrorMessage';
import FlexWrap from '../common/FlexWrap';
import Icon from '../common/Icon';
import Typography from '../common/Typography';
import BirthDate from './BirthDate';
import ExpireDateModal from './ExpireDateModal';
import TemporaryStorageModal from './TemporaryStorageModal';
import ValidateKorModal from './ValidateKorModal';
import LoadingView from '../common/LoadingView';
import ExpiredDateModal from '../common/ExpiredDate.modal';
import ICON_RADIO from '@/assets/refund/icon_radio.png';
import { NATIONALITY_GUIDE_LIST } from '@/constants/refund.const';
import { getImageOfNation } from '@/constants/book';
import NationalityGuideModal from './NationalityGuide.modal';

interface IProps {
  setLeafletModalInfo: Dispatch<
    SetStateAction<{
      active: boolean;
      isOver600: boolean;
      isKioskError: boolean;
    }>
  >;
  setIsRefund: Dispatch<SetStateAction<boolean>>;
  setIsPayment: Dispatch<SetStateAction<boolean>>;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  isExpired: boolean;
  setisCustomKor: React.Dispatch<React.SetStateAction<boolean>>;
  setisCustomLeaflet: React.Dispatch<React.SetStateAction<boolean>>;
  setIsOpenChartModal: (state: boolean) => void;
  isOpenChartModal?: boolean;
  setIsDuplicateRefund: (value: boolean) => void;
}
export interface ITourist {
  supplyDate: string;
  name: string;
  nationality: string;
  passportNumber: string;
  saleDate: string;
  birthYear: string;
  birthMonth: string;
  birthDay: string;
}

function TouristInputDummy({
  setLeafletModalInfo,
  setIsRefund,
  setIsPayment,
  isExpired,
  setIsOpen,
  setisCustomKor,
  setisCustomLeaflet,
  setIsOpenChartModal,
  isOpenChartModal,
  setIsDuplicateRefund,
}: IProps) {
  // 더미 상태 관리
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);
  const [selectedItemIndex, setSelectedItemIndex] = useState(-1);
  const [isOpenNationalityGuideModal, setIsOpenNationalityGuideModal] =
    useState(false);
  const [expireDate, setExpireDate] = useState({
    year: '',
    month: { label: '', value: '' },
    day: '',
  });

  const dropDownRef = useRef<HTMLUListElement>(null);
  let inputValueRef = useRef({ label: '', value: '' });

  // 더미 데이터
  const tempList: any[] = [];
  const errors: any = {};
  const isLoading = false;
  const isPassportCheck = false;
  const isFullFilled = false;
  const validatetErrorMessage = '';
  const isError = false;
  const isExpireDateFailed = false;
  const isStorageModal = false;
  const isValidateKorModal = false;
  const isLoadingForce = false;
  const isOpenExpired = false;

  // 더미 함수들
  const register = (...args: any[]) => ({});
  const onChange = (...args: any[]) => {};
  const onSubmit = (...args: any[]) => {};
  const onEdit = (...args: any[]) => {};
  const setValue = (...args: any[]) => {};
  const handleSubmit =
    (...args: any[]) =>
    (...args2: any[]) => {};
  const forceRefundMutation = (...args: any[]) => {};
  const createFormattedBirthDate = (...args: any[]) => '';
  const setIsOpenExpired = (...args: any[]) => {};

  return (
    <Container>
      <Form onSubmit={(e) => e.preventDefault()}>
        <FlexWrap alignItems='center' justifyContent='space-between'>
          <FlexWrap gap='32px'>
            <Title>외국인 관광객 정보</Title>
            <TemporaryStorage
              onClick={(e) => e.preventDefault()}
              style={{ pointerEvents: 'none' }}
            >
              <Icon imgUrl={menuBarIcon} width='16px' height='16px' />
              <Typography color='#5F6165'>
                임시 저장 목록(
                {tempList ? tempList.length?.toString().padStart(2, '0') : '00'}
                건)
              </Typography>
            </TemporaryStorage>
          </FlexWrap>
        </FlexWrap>
        <InputWrapper>
          <TopSection>
            <WarningIcon>!</WarningIcon>
            <WarningText>
              <WarningTitle>택스리펀 등록 서비스 운영 중단</WarningTitle>
              <WarningDescription>
                정부 정책 변경으로 인해 의료 택스리펀 웹 서비스 기능이
                중단되었습니다. 본 기능은 더 이상 사용할 수 없는 점
                양해부탁드립니다.
              </WarningDescription>
            </WarningText>
          </TopSection>
          <InputContainer>
            {/* 시술일자 */}
            <InputContent>
              <Label>시술일자</Label>
              <Input
                {...register('supplyDate')}
                maxLength={10}
                type='text'
                disabled={true}
                tabIndex={-1}
                placeholder='YYYYMMDD'
                autoComplete='off'
                onChange={(e) => {}}
              />
              {errors.supplyDate && (
                <ErrorMessage
                  text={String(errors.supplyDate.message)}
                  absolute
                />
              )}
            </InputContent>
            {/* 성별 */}
            <InputContent>
              <Label>성별</Label>
              <RadioGroup>
                <RadioWrapper isOk={false}>
                  <img src={ICON_RADIO} alt='' width={24} height={24} />
                  <RadioNone
                    type='radio'
                    name='gender'
                    onChange={() => setValue('gender', 'F')}
                    value='F'
                    checked={false}
                    disabled={true}
                    tabIndex={-1}
                  />
                  여성
                </RadioWrapper>

                <RadioWrapper isOk={false}>
                  <img src={ICON_RADIO} alt='' width={24} height={24} />
                  <RadioNone
                    type='radio'
                    name='gender'
                    value='M'
                    onChange={() => setValue('gender', 'M')}
                    checked={false}
                    disabled={true}
                    tabIndex={-1}
                  />
                  남성
                </RadioWrapper>
              </RadioGroup>
            </InputContent>
          </InputContainer>
          <InputContainer>
            {/* 성명 */}
            <InputContent>
              <Label>성명</Label>
              <Input
                {...register('touristName', {
                  required: true,
                })}
                type='text'
                disabled={true}
                tabIndex={-1}
                placeholder='영문만 입력(성 이름 기재)'
                autoComplete='off'
                isKoreaWord={!!errors.touristName}
                onChange={(e) => onChange(e)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                  }
                }}
              />
              {errors.touristName && (
                <ErrorMessage
                  text={String(errors.touristName.message)}
                  absolute
                />
              )}
            </InputContent>
            {/* 여권번호 */}
            <InputContent>
              <Label>여권번호</Label>
              <Input
                {...register('passportNumber', {
                  required: true,
                })}
                type='text'
                disabled={true}
                tabIndex={-1}
                placeholder='여권번호 입력'
                autoComplete='off'
                autoCapitalize='characters'
                onChange={(e) => onChange(e)}
              />
              {errors.passportNumber && (
                <ErrorMessage
                  text={String(errors.passportNumber.message)}
                  absolute
                />
              )}
            </InputContent>
          </InputContainer>
          <InputContainer>
            {/* 생년월일 */}
            <InputContent>
              <BirthDate
                expireDate={expireDate}
                setExpireDate={setExpireDate}
                setIsDropDownOpen={setIsDropDownOpen}
                inputValueRef={inputValueRef}
                selectedItemIndex={selectedItemIndex}
                isDropDownOpen={isDropDownOpen}
                setSelectedItemIndex={setSelectedItemIndex}
                dropDownRef={dropDownRef}
              />
            </InputContent>
            {/* 국적 */}
            <InputContent>
              <Label>국적</Label>
              <Input
                {...register('nationality', {
                  required: true,
                  minLength: { value: 3, message: '3글자로 입력해주세요.' },
                  maxLength: { value: 3, message: '3글자로 입력해주세요.' },
                })}
                type='text'
                disabled={true}
                tabIndex={-1}
                placeholder='거주국가(국적)'
                autoComplete='off'
                maxLength={3}
                onChange={(e) => onChange(e)}
              />
              {errors.nationality && (
                <ErrorMessage
                  text={String(errors.nationality.message)}
                  absolute
                />
              )}
            </InputContent>
          </InputContainer>
          <NationalityGuide>
            <NationalityGuideWrapper>
              {NATIONALITY_GUIDE_LIST.map((nation, index) => (
                <NationalityItem key={index}>
                  <img
                    src={getImageOfNation(nation.value)}
                    alt={nation.value}
                    width={16}
                    height={16}
                  />
                  <span>
                    {nation.label} ({nation.value})
                  </span>
                </NationalityItem>
              ))}
            </NationalityGuideWrapper>
            <GuideButton
              type='button'
              disabled={true}
              tabIndex={-1}
              onClick={(e) => {
                e.preventDefault();
                setIsOpenNationalityGuideModal(true);
              }}
            >
              <KuiIcon.QuestionFilled fillColor='#CBCCCE' size={19.3} />
              <span>국적 입력 가이드</span>
            </GuideButton>
          </NationalityGuide>
          <ButtonContainer>
            {validatetErrorMessage && (
              <ErrorMessage text={validatetErrorMessage} margin='0 10px 0 0' />
            )}
            <Button
              isActive={false}
              isValidate={(isPassportCheck && isFullFilled) || isError}
              disabled={true}
              tabIndex={-1}
              onClick={isPassportCheck ? onEdit : handleSubmit(onSubmit)}
            >
              {isLoading ? (
                <LoadingView height='100%' />
              ) : isPassportCheck ? (
                '정보 수정'
              ) : (
                '여권 확인'
              )}
            </Button>
          </ButtonContainer>
        </InputWrapper>
      </Form>
      {isExpireDateFailed && (
        <ExpireDateModal
          isLoading={isLoading}
          onSubmit={onSubmit}
          expireDate={expireDate}
          setExpireDate={setExpireDate}
          inputValueRef={inputValueRef}
          selectedItemIndex={selectedItemIndex}
          setSelectedItemIndex={setSelectedItemIndex}
          isDropDownOpen={isDropDownOpen}
          setIsDropDownOpen={setIsDropDownOpen}
          dropDownRef={dropDownRef}
        />
      )}

      {tempList && isStorageModal && <TemporaryStorageModal data={tempList} />}
      {isValidateKorModal && (
        <ValidateKorModal
          forceRefundMutation={forceRefundMutation}
          isLoading={isLoadingForce}
          onChange={onChange}
          createFormattedBirthDate={createFormattedBirthDate}
        />
      )}
      {isOpenExpired && (
        <ExpiredDateModal onClose={() => setIsOpenExpired(false)} />
      )}
      {isOpenNationalityGuideModal && (
        <NationalityGuideModal
          onClose={() => setIsOpenNationalityGuideModal(false)}
        />
      )}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  gap: 20px;
  pointer-events: none;
  cursor: not-allowed;
  user-select: none;

  * {
    pointer-events: none !important;
    cursor: not-allowed !important;
    user-select: none !important;
  }
`;

const Title = styled.h3`
  font-size: ${(props) => props.theme.fontSize.regular};
  font-weight: ${(props) => props.theme.fontWeight.bold};
  line-height: ${(props) => props.theme.lineHeight.regular};
  color: ${(props) => props.theme.mono[80]};
`;

const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 116px;
  border-radius: 16px 16px 0 0;
  background: var(--KTP-Grayscale-Gray_09, #ccc);
  margin: -38px -52px 0;
  padding: 26px 32px 17px;

  @media ${(props) => props.theme.laptop} {
    margin: -38px -20px 0;
  }
`;

const WarningIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding-top: 4px;
  border-radius: 50%;
  background-color: #949494;
  color: #333333;
  font-size: 20px;
  font-weight: 800;
  flex-shrink: 0;
`;

const WarningText = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const WarningTitle = styled.div`
  color: var(--KTP-Grayscale-Gray_03, #333);
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%; /* 33.6px */
  letter-spacing: -0.48px;
`;

const WarningDescription = styled.div`
  padding-top: 4px;
  color: var(--KTP-Grayscale-Gray_03, #333);
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 170%; /* 27.2px */
  letter-spacing: -0.32px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
  margin-top: 24px;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
  padding: 38px 52px;
  background-color: #ececec;
  border-radius: 16px;
  @media ${(props) => props.theme.laptop} {
    gap: 18px;
    padding: 38px 20px;
  }
`;

const InputContainer = styled.div`
  display: flex;
  gap: 100px;
  position: relative;
  @media ${(props) => props.theme.largeView} {
    gap: 120px;
  }
`;

const InputContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  width: 100%;
`;

const Label = styled.label`
  color: ${(props) => props.theme.mono[80]};
`;

const Input = styled.input<{ isKoreaWord?: boolean }>`
  width: 80%;
  height: 48px;
  border-radius: 4px;
  padding-left: 10px;
  outline: none;
  text-transform: uppercase;
  border: 1.5px solid
    ${(props) =>
      props.isKoreaWord
        ? props.theme.priamryColors.error
        : props.theme.mono[20]};
  color: ${(props) =>
    props.isKoreaWord ? props.theme.priamryColors.error : '#212121'};
  background-color: #fff;
  :focus {
    background-color: ${(props) => props.theme.blue[5]};
    border-color: ${(props) =>
      props.isKoreaWord
        ? props.theme.priamryColors.error
        : props.theme.blue[100]};
  }
  ::placeholder {
    color: ${(props) =>
      props.isKoreaWord
        ? props.theme.priamryColors.error
        : props.theme.mono[35]};
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
const Button = styled.button<{ isActive?: boolean; isValidate?: boolean }>`
  width: 240px;
  font-size: ${(props) => props.theme.fontSize.small};
  line-height: 150%;
  padding: 14px 0;
  border-radius: 8px;
  font-weight: ${(props) => props.theme.fontWeight.medium};
  color: ${(props) => props.theme.pointColors.white};
  background-color: #ccc;
`;

const TemporaryStorage = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
`;

const RadioWrapper = styled.label<{ isOk: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  color: ${({ isOk }) => (isOk ? '#246CF6' : '#80848a')};
  cursor: pointer;
`;

const RadioNone = styled.input`
  display: none;
`;

const RadioGroup = styled.div`
  width: 80%;
  display: flex;
  gap: 24px;
`;

const NationalityGuide = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  top: -16px;
`;

const NationalityGuideWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  row-gap: 4px;
  column-gap: 10px;
  @media ${(props) => props.theme.laptop} {
    width: 300px;
  }
`;

const NationalityItem = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  span {
    padding-top: 2px;
    color: var(--KTP-Grayscale-Gray_05, #777);
    text-align: center;
    font-family: Pretendard;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    letter-spacing: -0.24px;
  }
`;

const GuideButton = styled.button`
  padding: 5px 10px;
  margin-left: 20px;
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  cursor: pointer;

  color: var(--KTP-Grayscale-Gray_05, #777);
  text-align: center;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 18px */
  letter-spacing: -0.24px;

  border-radius: 4px;
  border: 1px solid var(--KTP-Grayscale-Gray_09, #ccc);

  span {
    padding-top: 2px;
  }
`;

export default TouristInputDummy;
